import React from "react";
import korner from "../assets/projectAssets/korner.gif";
import "../styles/project.css";

const Korner = () => {
  return (
    <div className="project-content">
      <h3>Korner</h3>
      <a href="https://github.com/DhruvGupta3377/korner" target="_blank">
            SourceCode
          </a>
      <img src={korner} />
      <h3>Technologies used</h3>
      Rust, Windows API
      <h3>Why?</h3>
      Linux has Hotcorners Windows doesn't when I was using linux I enjoyed using it.
      Just going to the left corner triggers task view no need to win + tab. 
      <h3>What is this?</h3>
      <li>Implemented a Linux HotCorner like utility for windows.</li>
      <li>Going to the top left corner triggers Task View for windows.</li>
      <li>
        Shortcuts can be changed by adding different keys in the Source code.
      </li>
    </div>
  );
};

export default Korner;
